<template lang="pug">
  
  // PAGE TITLE
  span(v-if="type === 'headerTitle'") {{ customer.title }}
  
  // PAGE SLOGAN
  span(v-else-if="type === 'headerSlogan'") {{ customer.slogan }}

  // HEADER CDU LOGO
  span(v-else-if="type === 'headerCDULogo'")
    img(v-if="customer.cduLogo == 'nrw'" src="~@/assets/img/cdu_nrw_logo.png" alt="CDU NRW")
    img(v-else-if="customer.cduLogo == 'schermbeck'" src="~@/assets/img/cdu_schermbeck_logo.png" alt="CDU Schermbeck")
    img(v-else src="~@/assets/img/cdu_logo.png" alt="CDU")  

  // HEADER SOCIALMEDIA ICONS 
  span(v-else-if="type === 'headerSocial'")
    ul.header-icon-menu
      li(v-if="customer.facebook")
        a(:href="customer.facebook" target="_blank")
          span.icon
            font-awesome-icon(:icon="['fab', 'facebook-f']")
          span.title Facebook
      li(v-if="customer.instagram")
        a(:href="customer.instagram" target="_blank" )
          span.icon
            font-awesome-icon(:icon="['fab', 'instagram']")
          span.title Instagram
      li(v-if="customer.newsletter")
        router-link(:to="customer.newsletter")
          span.icon
            font-awesome-icon(:icon="['fas', 'envelope']")
          span.title Newsletter

  // FOOTER SOCIALMEDIA ICONS 
  span(v-else-if="type === 'footerSocial'")
    ul.social-links-footer
      li(v-if="customer.facebook")
        a(:href="customer.facebook" target="_blank" title="Facebook")
          span.icon
            font-awesome-icon(:icon="['fab', 'facebook-f']")
      li(v-if="customer.instagram")
        a(:href="customer.instagram" target="_blank" title="Instagram")
          span.icon
            font-awesome-icon(:icon="['fab', 'instagram']")

  // FOOTER ADDRESS
  span(v-else-if="type === 'footerAddress'")
    address(v-if="customer.address.contactperson") {{ customer.address.contactperson }} <br>
      | {{ customer.address.street }} <br>
      | {{ customer.address.zipStreet }} <br>
      a(v-if="customer.address.email" :href="`mailto:${customer.address.email}`") {{ customer.address.email }} <br v-if="customer.address.email2">
      a(v-if="customer.address.email2" :href="`mailto:${customer.address.email2}`") {{ customer.address.email2 }}

      p(v-if="customer.address.tel || customer.address.mobil")
        a(v-if="customer.address.tel" :href="`tel:${customer.address.tel}`") T.: {{ customer.address.tel }} <br>
        a(v-if="customer.address.mobil" :href="`tel:${customer.address.mobil}`") M.: {{ customer.address.mobil }}

</template>

<script>
export default {
    name: 'CDUCustomers',
    props: {
        type: {
            type: String
        }
    },
    computed: {
        url() {
            let url = window.location.href;
            let domain = new URL(url);
            domain = domain.hostname;
            return domain;
        },
        customer() {
            let title,slogan,cduLogo,facebook,instagram,newsletter,address;
            
            switch (this.url) {
                case 'guenther-bergmann.de':
                case 'guentherbergmann.de':
                case 'www.guentherbergmann.de':
                case 'www.guenther-bergmann.de':
                    title = 'Dr. Günther Bergmann';
                    slogan = 'Starkes Land. Starker Kreis.';
                    cduLogo = 'nrw';
                    facebook = 'https://www.facebook.com/drguentherbergmann/';
                    instagram = 'https://www.instagram.com/guenther.bergmann/';
                    newsletter = 'newsletter';
                    address = {
                      contactperson: 'Landtag Nordrhein-Westfalen',
                      street: 'Postfach 10 11 43',
                      zipStreet: '40002 Düsseldorf',
                      email: 'guenther.bergmann@landtag.nrw.de',
                      email2: undefined,
                      tel: undefined,
                      mobil: undefined
                    }
                    break;
                case 'cdu-schermbeck.de':
                case 'www.cdu-schermbeck.de':
                case 'cdu-schermbeck.de.37-61-201-233.vanameland05.de':
                    title = 'CDU Schermbeck';
                    slogan = 'Weiter. Gemeinsam. Erfolgreich.';
                    cduLogo = 'schermbeck';
                    facebook = 'https://www.facebook.com/cduschermbeck/';
                    instagram = 'https://www.instagram.com/cduschermbeck/';
                    newsletter = undefined;
                    address = {
                      contactperson: 'Ulrich Stiemer | CDU Schermbeck',
                      street: 'Marellenkämpe 15',
                      zipStreet: '46514 Schermbeck',
                      email: ' info@cdu-schermbeck.de',
                      email2: undefined,
                      tel: '02853 954037',
                      mobil: undefined
                    }
                    break;
                case 'mike-rexforth.de':
                case 'www.mike-rexforth.de':
                case 'mike-rexforth.de.37-61-201-233.vanameland05.de':
                case '127.0.0.1':
                    title = 'Mike Rexforth';
                    slogan = 'Weiter. Gemeinsam. Erfolgreich.';
                    cduLogo = 'schermbeck';
                    facebook = 'https://www.facebook.com/MikeRexforth.BM';
                    instagram = 'https://www.instagram.com/mike.rexforth/';
                    newsletter = undefined;
                    address = {
                      contactperson: 'Mike Rexforth | CDU Schermbeck',
                      street: 'Weseler Straße 2',
                      zipStreet: '46514 Schermbeck',
                      email: 'info@mike-rexforth.de',
                      email2: 'admin@cdu-schermbeck.de',
                      tel: '02853 9100',
                      mobil: undefined
                    }
                    break;
                default:
                    title = 'CDU NRW Template';
                    slogan = 'CDU NRW Slogan';
                    cduLogo = 'cdu';
                    facebook = 'https://www.facebook.com/CDUnrw';
                    instagram = 'https://www.instagram.com/cdunrw';
                    newsletter = 'newsletter';
                    address = {
                      contactperson: 'CDU NRW Kreis/Ansprechparner',
                      street: 'Wasserstraße 6',
                      zipStreet: '40002 Düsseldorf',
                      email: 'info@cdu-nrw.de',
                      email2: undefined,
                      tel: undefined,
                      mobil: undefined
                    } 
                    break;
            }
            return {
              title,
              slogan,
              cduLogo,
              facebook,
              instagram,
              newsletter,
              address
            };
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.header-icon-menu
  padding-top: 12px
  li
    @apply float-left h-full p-0 m-0 text-base leading-none uppercase text-white mr-3
    @screen sm
      @apply mr-0 ml-4
    &:hover
      .icon
        @apply bg-white
        color: $color-secondary
    .icon
      @apply border-2 border-white border-solid relative inline-block text-center align-middle rounded-full
      padding-top: 3px
      line-height: 27px
      font-size: 17px
      width: 33px
      height: 33px
      .svg-inline--fa
        line-height: 33px
    .title
      @apply hidden
      margin-left: 6px
      font-size: 0.8em
      @screen sm
        @apply inline

.social-links-footer
  li
    @apply inline-block ml-3
    &:hover .icon
      background-color: $color-secondary
      border-color: $color-secondary
    .icon
      @apply border-2 border-white border-solid relative inline-block text-center align-middle rounded-full
      padding-top: 3px
      line-height: 36px
      font-size: 22px
      width: 40px
      height: 40px
      .svg-inline--fa
        line-height: 40px

</style>
